/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
import { Grid, Paper, Box, Typography, IconButton } from '@mui/material';
import './NavigationSteps.styles.css';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
// import  bannerLogoIcon  from '../../assets/images/CBP-logo-banner.svg';

type NavigationStepsPropsType = {
  handleClick?: () => void;
  handleBack?: () => void;
  stepsData: {
    step: string;
    label: string;
  };
  forward?: boolean;
};

const NavigationSteps = ({
  handleClick,
  handleBack,
  stepsData,
  forward = false,
}: NavigationStepsPropsType) => {
  return (
    <Grid size={{ xs: 12 }}>
      <Paper className="NavigationBox">
        <IconButton
          className="NavigationArrow ArrowLeft"
          disabled={!handleBack}
          onClick={handleBack}
        >
          <KeyboardArrowLeftOutlinedIcon />
        </IconButton>
        <Box className="NavigationInfo">
          <Typography variant="h6">Step {stepsData.step} of 3</Typography>
          <Typography variant="h4">{stepsData.label}</Typography>
        </Box>
        {!!handleClick ? (
          <IconButton
            className="NavigationArrow ArrowRight"
            onClick={handleClick}
            disabled={!forward}
          >
            <KeyboardArrowRightOutlinedIcon />
          </IconButton>
        ) : (
          <IconButton
            className="NavigationArrow ArrowRight"
            style={{ border: 'none', width: 0 }}
          ></IconButton>
        )}
      </Paper>
    </Grid>
  );
};

export default NavigationSteps;
